module.exports = __webpack_public_path__ + "static/media/CMS-gem.0d7e5b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/thumbs/CMS-gem.png
// module id = 617
// module chunks = 0